<div class="games-with-tickets-list">
  <h5 class="games-with-tickets-list-title">{{ 'fgbcl.games.with.tickets.list.home.title' | translate }}</h5>
  <fgbcl-games-list-with-tickets [filters]="ticketsFilters" [sortOptions]="ticketsSortOptions">
    <div class="no-games-placeholder">{{ 'fgbcl.games.with.tickets.list.home.games.no.games' | translate }}</div>
  </fgbcl-games-list-with-tickets>

  <h5 class="games-with-tickets-list-title clickable" (click)="toggle()" #pastGamesTitle>
    <i class="material-icons" [@rotateAnimation]="{ value: isPastGamesOpen, params: { rotateStart: 0, rotateEnd: 90 } }"
      >chevron_right</i
    >{{ 'fgbcl.games.with.tickets.list.past.title' | translate }}
  </h5>
  <div [@collapseAnimation]="isPastGamesOpen">
    <!-- Lazy load component, Hides in DOM while no interaction, shows when pastGamesTitle is clicked -->
    @defer (on interaction(pastGamesTitle)) {
      <fgbcl-games-list-with-tickets [filters]="pastTicketsFilters" [sortOptions]="pastTicketsSortOptions">
        <div class="no-games-placeholder">{{ 'fgbcl.games.with.tickets.list.past.games.no.games' | translate }}</div>
      </fgbcl-games-list-with-tickets>
    }
  </div>
</div>
